import "./App.css";

import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router";

import { AuthenticatedApolloProvider } from "./components/AuthenticatedApolloProvider/AuthenticatedApolloProvider";
import { ErrorWrapper } from "./components/Errors/ErrorWrapper";
import { LoadingScreen } from "./components/LoadingScreen/LoadingScreen";
import PlayerWrapper from "./components/PlayerWrapper/PlayerWrapper";
import { useAppLoadingState } from "./hooks/useAppLoadingState";
import { Authorizer } from "./pages/Authorizer/Authorizer";
import { Library } from "./pages/Library/Library";
import { Player } from "./pages/Player/Player";
import { TelemetryAwaitingEmitter } from "./telemetry/TelemetryUtils";

function App(): React.ReactElement {
  const { isLoading, loadingMessage } = useAppLoadingState();

  const handleContextMenu = (event: MouseEvent) => {
    const urlParams = new URLSearchParams(window.location.search);
    const debug = urlParams.get("debug") === "true";
    const parent = document.getElementById("zopim-widget");
    const target = event.target as HTMLElement;

    if ((!parent || (parent && target && !parent.contains(target))) && !debug) {
      event.preventDefault();
    } else {
      return true;
    }
  };

  useEffect(() => {
    document.getElementById("App")?.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.getElementById("App")?.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Show loading state when isLoading is true
  if (isLoading) {
    return <LoadingScreen message={loadingMessage} />;
  }

  return (
    <div className="App" id="App" style={{ display: "flex" }}>
      <ErrorWrapper>
        <TelemetryAwaitingEmitter />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <AuthenticatedApolloProvider>
                  <PlayerWrapper>
                    <Library />
                  </PlayerWrapper>
                </AuthenticatedApolloProvider>
              }
            />
            <Route path="/authorize" element={<Authorizer />} />
            <Route
              path="/previewer"
              element={
                <AuthenticatedApolloProvider requiredRole="ondemandPreview">
                  <PlayerWrapper>
                    <Player testMode={true} />
                  </PlayerWrapper>
                </AuthenticatedApolloProvider>
              }
            />
            <Route
              path="/:courseId"
              element={
                <AuthenticatedApolloProvider>
                  <PlayerWrapper>
                    <Player />
                  </PlayerWrapper>
                </AuthenticatedApolloProvider>
              }
            />
          </Routes>
        </BrowserRouter>
      </ErrorWrapper>
    </div>
  );
}

export default App;
